import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import FbMessageAttachmentsContainer from './attachments/fb_message_attachments';
import ItemCommError from '../item_comm_error';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import { Status as FbMessageOutgoingStatus } from 'models/fb_message_outgoing';
import Linkifier from 'components/lib/linkifier';

export default function FacebookOutgoingItem({ className, isFirstInStack, isLastInStack, isStacked, item }) {
  return (
    <ItemContent
      isFirstInStack={isFirstInStack}
      isLastInStack={isLastInStack}
      isStacked={isStacked}
      item={item}
      showIcon={!isStacked}
    >
      <ItemMetadata item={item} showMetadata={!isStacked} status={getStatus(item)} />
      <FacebookOutgoingContent className={className} item={item} />
      <ItemCommError item={item} />
    </ItemContent>
  );

  function getStatus() {
    const status = item.content.getStatus();
    switch (status) {
      case FbMessageOutgoingStatus.FAILED:
        return 'delivery failed';
      case FbMessageOutgoingStatus.NEW:
        return 'sending';
      case FbMessageOutgoingStatus.SENT:
        return 'delivered';
      default:
        return undefined;
    }
  }
}

FacebookOutgoingItem.propTypes = {
  className: PropTypes.string,
  isFirstInStack: PropTypes.bool,
  isLastInStack: PropTypes.bool,
  isStacked: PropTypes.bool,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};

export function FacebookOutgoingContent({ className, item }) {
  return (
    <BubbleContent className={classnames('facebookOutgoingItem-content', className)} item={item}>
      {renderText()}
      {renderAttachment()}
    </BubbleContent>
  );

  function renderText() {
    const text = _.get(item, 'content.request.message.text');
    if (!text) {
      return null;
    }

    return <Linkifier>{text}</Linkifier>;
  }

  function renderAttachment() {
    const attachment = item.content.request.message.attachment;
    if (!attachment) {
      return null;
    }

    return <FbMessageAttachmentsContainer attachments={[attachment]} />;
  }
}

FacebookOutgoingContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/facebook/facebook_outgoing_item.jsx